import { FontEntry } from '../../types/font'

export const everett: FontEntry = {
  displayName: 'Everett',
  weights: {
    300: {
      normal: { file: 'TWKEverett-Light', extension: 'woff', format: 'woff' },
      italic: { file: 'TWKEverett-LightItalic', extension: 'woff2', format: 'woff2' }
    },
    400: {
      normal: { file: 'TWKEverett-Regular', extension: 'woff2', format: 'woff2' },
      italic: { file: 'TWKEverett-RegularItalic', extension: 'woff', format: 'woff' }
    },
    700: {
      normal: { file: 'TWKEverett-Bold', extension: 'woff2', format: 'woff2' },
      italic: { file: 'TWKEverett-BoldItalic', extension: 'woff2', format: 'woff2' }
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 108.27,
        ascentOverride: 93.29,
        descentOverride: 19.49,
        lineGapOverride: 9.24
      },
      bold: {
        sizeAdjust: 105.76,
        ascentOverride: 95.5,
        descentOverride: 19.95,
        lineGapOverride: 9.46
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 109.85,
        ascentOverride: 91.94,
        descentOverride: 19.21,
        lineGapOverride: 9.1
      },
      bold: {
        sizeAdjust: 112.04,
        ascentOverride: 90.14,
        descentOverride: 18.83,
        lineGapOverride: 8.93
      }
    }
  }
}
